export default {
  reset_password_title: "Réinitialiser le mot de passe",
  reset_pass_desc:
    "Veuillez saisir votre adresse email et nous vous enverrons un lien pour réinitialiser votre mot de passe.",
  reset_pass: "Réinitialiser le mot de passe",
  reset_pass_requested: "Demande de réinitialisation du mot de passe reçue",
  reset_pass_check_email:
    "Veuillez consulter votre email et suivre les instructions pour réinitialiser votre mot de passe.",
  reset_pass_email_sent_info:
    "Si cet email existe dans notre système, un lien de réinitialisation du mot de passe a été envoyé.",
  reset_pass_did_not_receive:
    "Vous n'avez pas reçu l'email ? Veuillez vérifier votre dossier spam.",
  reset_pass_resend_email: "Renvoyer l'email de réinitialisation du mot de passe",
  reset_pass_resend_available_in: "Renvoi disponible dans {seconds} secondes",
  reset_pass_resending: "Renvoi en cours...",
  reset_pass_resent_success: "Email de réinitialisation du mot de passe renvoyé avec succès",
  reset_pass_please_wait: "Veuillez patienter {seconds} secondes avant de renvoyer",
  reset_pass_request_failed: "Échec de la demande de réinitialisation du mot de passe",
  email_required: "Veuillez saisir votre adresse email",
  email_invalid: "Veuillez saisir une adresse email valide",
  email_placeholder: "votre{0}exemple.com",
  daily_limit_reached: "Limite quotidienne de renvoi atteinte. Veuillez réessayer demain.",
  remaining_attempts: "{count} tentatives restantes aujourd'hui",
};
